// Live theme helpers — apply CMS-editable colours + fonts at runtime.
// Colours map to the --kazo-* CSS variables; fonts to --font-display / --font-body.
import { BRAND } from "@/brand.config";

// Curated Google Fonts (all expose 400 + 700 weights).
export const FONT_OPTIONS = [
  "Inter", "Manrope", "Poppins", "Montserrat", "Raleway", "Nunito",
  "Josefin Sans", "Space Grotesk", "Oswald", "Playfair Display",
  "Cormorant Garamond", "Lora", "Merriweather", "Libre Baskerville", "PT Serif",
];

export function loadGoogleFont(name) {
  if (!name || name === "Inter") return; // Inter already bundled
  const id = `gf-${name.replace(/\s+/g, "-")}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${name.replace(/\s+/g, "+")}:wght@400;700&display=swap`;
  document.head.appendChild(link);
}

export function applyTheme(content) {
  const root = document.documentElement.style;
  const t = (content && content.theme) || {};
  const c = t.colors || {};
  root.setProperty("--kazo-black", c.black || BRAND.colors.black);
  root.setProperty("--kazo-cream", c.cream || BRAND.colors.cream);
  root.setProperty("--kazo-burgundy", c.burgundy || BRAND.colors.burgundy);
  root.setProperty("--kazo-burgundy-deep", c.burgundyDeep || BRAND.colors.burgundyDeep);
  root.setProperty("--kazo-champagne", c.champagne || BRAND.colors.champagne);
  root.setProperty("--kazo-champagne-light", c.champagneLight || BRAND.colors.champagneLight);

  const disp = t.display_font || "Inter";
  const body = t.body_font || "Inter";
  loadGoogleFont(disp);
  loadGoogleFont(body);
  root.setProperty("--font-display", `'${disp}', system-ui, sans-serif`);
  root.setProperty("--font-body", `'${body}', system-ui, sans-serif`);
}
